import React from 'react';
import { AdminH1 } from '../../components/AdminH1';
import { useParams } from 'react-router-dom';
import PopUpTargetBranchTemplate from '../../components/templates/PopUpTargetBranchTemplate';

export const PopUpTargetBranchShow = () => {
  const { id } = useParams<{ id: string }>();
  const numId = Number(id);
  return (
    <>
      <AdminH1>팝업 문의 지점 상세</AdminH1>
      <PopUpTargetBranchTemplate type={'EDIT'} targetId={numId} />
    </>
  );
};
